import React, {useState, useEffect} from "react";
import UnitsList from "./UnitsList";
import UnitEditor from "./UnitEditor";
import Notification from "../Common/Notification";

const UnitsSettings = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedAll, setSelectedAll] = useState(false);
    const [showEditor, setShowEditor] = useState(false);
    const [currentUnit, setCurrentUnit] = useState(null);
    const [notification, setNotification] = useState({
        show: false,
        type: 'success',
        message: '',
    });

    // Debounce search term
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 300);

        return () => clearTimeout(timer);
    }, [searchTerm]);

    // Function to show a notification
    const showNotification = (type, message) => {
        setNotification({
            show: true,
            type,
            message,
        });

        if (type === 'success') {
            setTimeout(() => {
                setNotification(prev => ({...prev, show: false}));
            }, 5000);
        }
    };

    // Function to hide notification
    const hideNotification = () => {
        setNotification(prev => ({...prev, show: false}));
    };

    // Handle create new unit
    const handleCreateUnit = () => {
        setCurrentUnit(null);
        setShowEditor(true);
    };

    // Handle edit unit
    const handleEditUnit = (unit) => {
        setCurrentUnit(unit);
        setShowEditor(true);
    };

    // Handle back from editor
    const handleCloseEditor = () => {
        setShowEditor(false);
        setCurrentUnit(null);
    };

    return (
        <div>
            <UnitsList
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                debouncedSearchTerm={debouncedSearchTerm}
                selectedItems={selectedItems}
                setSelectedItems={setSelectedItems}
                selectedAll={selectedAll}
                setSelectedAll={setSelectedAll}
                showNotification={showNotification}
                onCreateUnit={handleCreateUnit}
                onEditUnit={handleEditUnit}
            />

            {showEditor && (
                <UnitEditor
                    unit={currentUnit}
                    onClose={handleCloseEditor}
                    showNotification={showNotification}
                />
            )}

            {/* Notification */}
            {notification.show && (
                <Notification
                    type={notification.type}
                    message={notification.message}
                    onClose={hideNotification}
                />
            )}
        </div>
    );
};

export default UnitsSettings;

